import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  SearchField,
  Box,
  SimpleList,
  Paginator,
  Divider,
  CircularProgress,
  Button,
  Typography,
} from "@tiny/components";
import { useCleanedListHistoryDialog } from "./CleanedListHistoryDialog.hooks";
import CleanedListHistoryRow from "./CleanedListHistoryRow";

export interface CleanedListHistoryDialogProps {
  open: boolean;
  onClose: () => void;
  segmentId: string;
}

function CleanedListHistoryDialog(props: CleanedListHistoryDialogProps) {
  const { open, onClose, segmentId } = props;

  const {
    content,
    handlePageChange,
    handleSearchChange,
    handleSizeChange,
    itemsPerPage,
    itemsPerPageOptions,
    page,
    search,
    isLoading,
    totalCount,
    reloadHistories,
  } = useCleanedListHistoryDialog(props);

  const noData = !isLoading && (!content || content.length === 0);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      disableEscapeKeyDown
      disableBackdropClose
    >
      <DialogTitle subtitle="Select a file to download">
        Cleaned List History
      </DialogTitle>

      <DialogContent>
        <Box mb={3} display="flex" alignItems="center">
          <SearchField
            value={search}
            placeholder="Search by filename"
            onChangeValue={handleSearchChange}
            style={{ flex: 1 }}
          />
        </Box>
        {isLoading ? (
          <Box
            width="100%"
            height="300px"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            bgcolor="white"
          >
            <CircularProgress />
          </Box>
        ) : noData ? (
          <Box
            width="100%"
            height="300px"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            textAlign="center"
          >
            <Typography
              variant="h4"
              color="grey"
              tone={800}
              mb={2}
              fontWeight="semiBold"
            >
              No cleaned files found
            </Typography>
            <Typography variant="body2" color="grey" tone={600}>
              Please adjust the search criteria.
            </Typography>
          </Box>
        ) : (
          <>
            <SimpleList>
              {content?.map((row) => (
                <CleanedListHistoryRow
                  key={row.id}
                  item={row}
                  onDownloadComplete={reloadHistories}
                />
              ))}
            </SimpleList>
            <Divider mb={2} />
            <Paginator
              mt={4}
              totalCount={totalCount}
              page={page}
              itemsPerPage={itemsPerPage}
              itemsPerPageOptions={itemsPerPageOptions}
              onItemsPerPageChange={handleSizeChange}
              onPageChange={handlePageChange}
              itemsPerPageLabel="results"
            />
          </>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="text">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CleanedListHistoryDialog;
